<template>
  <div class="container" v-if="status == 'STATUS_EFFECTIVENESS'" :class="{'section-loading': changeLoading}">
    <h3 class="text-green m-0">{{tableRow.onenews[0].subject}}</h3>
    
    <table class="table table-basic mt-4 mb-4">
      <thead>
        <tr>
          <th>發佈日期</th>
          <td>{{ tableRow.onenews[0].star_date | dateFormat }}</td>
          <th>下架日期</th>
          <td>{{ tableRow.onenews[0].end_date | dateFormat }}</td>
        </tr>
        <tr>
          <th>申請者</th>
          <td>{{ tableRow.onenews[0].emp_nm }}</td>
          <th>申請日期</th>
          <td>{{ tableRow.onenews[0].ddate | dateFormat  }}</td>
        </tr>
        <tr>
          <th>最後編輯者</th>
          <td>{{ tableRow.onenews[0].upd_nm }}</td>
          <th>最後編輯時間</th>
          <td>{{ tableRow.onenews[0].upd_time  | dateFormat }}</td>
        </tr>
        
      </thead> 
    </table>
    <div class="breadcrumb row">
        <label class="col-1 text-right">路徑</label>
        <div class="col-11">
            <ul class="breadcrumb-list">
                <li class="bread"
                :class="{'active': breadcrumbs.length - 1 == i  }"
                v-for="(bread, i) in breadcrumbs"
                :key="`bread-${i}`">
                    <a v-if="bread.index !== currentTableIndex" role="button" 
                    @click="returnTable(bread, i)">{{bread.name}}</a>
                    <a v-else role="button" >{{bread.name}}</a>
                </li>
            </ul>
        </div>     
    </div>    
    <div>
      <table v-if="tableRow.dev_list && tableRow.dev_list.length && !isBottom" class="table datatable insurance-green">
        <thead>
            <tr>
              <th class="text-center">業務系統</th>
              <th class="text-center">點閱率</th>
              <th class="text-center">下載/點擊率</th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rid) in tableRow.dev_list"
          :key="`row-${rid}`">
            <td v-if="row.ta_count && row.ta_count > 0">
              <a @click="toNextTable(row)" class="link text-underline">{{row.cedvnm}}</a>
            </td>
            <td v-else>
              <a class="text">{{row.cedvnm}}</a>
            </td>
            <td class="text-center">
              <span>{{row.link_percentage}}%</span>
            </td>                      
            <td class="text-center">
              <span>{{row.click_download_percentage}}%</span>
            </td>
          </tr>
        </tbody>
        <!-- <tfoot v-if="tableRow && tableRow.length">
          <tr class="bg-white">
            <th class="text-center">合計</th>
            <th class="text-center">47</th>
            <th class="text-center">44</th>
          </tr>
        </tfoot> -->
      </table>
      <table v-else-if="tableRow.dev_list && tableRow.dev_list.length" class="table datatable insurance-green">
        <thead>
            <tr>
              <th class="text-center">姓名</th>
              <th class="text-center">點閱</th>
              <th class="text-center">下載/點擊</th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rid) in tableRow.dev_list[0].agnt_list"
          :key="`row-${rid}`">
            <td class="text-center">
              <span>{{ row.name }}</span>
            </td>                         
            <td class="text-center">
              <i v-if="row.isclick" class="icon-check mr-2 font-weight-bold"></i>
              <i v-else class="icon-close mr-2 text-danger font-weight-bold"></i>
            </td>                      
            <td class="text-center">
              <i v-if="row.isdownload" class="icon-check mr-2 font-weight-bold"></i>
              <i v-else class="icon-close mr-2 text-danger font-weight-bold"></i>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="bg-white">
            <th class="text-center">合計</th>
            <th class="text-center">{{ sumClick(tableRow.dev_list[0].agnt_list) }}%</th>
            <th class="text-center">{{ sumDownload(tableRow.dev_list[0].agnt_list) }}%</th>
          </tr>
        </tfoot>
      </table>
      <div v-else class="empty-block w-100" >
        <span>無符合條件名單。</span>
      </div>
      <p>點閱率=受眾點擊人數/受眾人數<br />
         下載/點擊率=受眾下載附件或點擊連結人數/受眾人數</p>
    </div>

    <div class="row float-right  mt-4">
      <button type="button" @click="backClickRateView" class="btn btn-primary mt-0">回查詢列表</button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import DataTable from '@/components/DataTable/DataTableCollapse'
import {commonMixin} from '@/mixins/common'
import ClickRateView from './ClickRateView'
import { getConditionMeesage,getMessageDataByID } from '@/service'
import { queryUnitBulletinEffect,getTacount } from '@/service'


export default {
  name: 'Effectiveness',
  mixins: [commonMixin],
  components: {
    DataTable
    ,ClickRateView
  },
  props: {
    'status': String,
    'message_id': Object,
  },
  computed: {
    isBottom () {  // 計算是不是底層
      if(this.tableRow.dev_list[0].agnt_list) {
        return true
      } else {
        return false
      } 
    },
  },
  data () {
    return {
      dataHeader1 : ['業務系統', '點閱率', '下載/點擊率'],
      changeLoading: false,   
      currentTableIndex: '',  
      tableRow: {
        onenews: [{}],
      }, //存取所有資料

      breadcrumbs:[],
      dataTree:{
        1:[],
        2:[],
        3:[],
      },
      searchType: 1,
      reasonType: 1,
      transferModalOpen: false,
    }
  },
  watch: {
    'status': function(val) {
      if(val == 'STATUS_EFFECTIVENESS') {
        this.currentTableIndex = 1
        this.breadcrumbs = []
        this.changeLoading = true
        let report ={}
        report.showclass = 1 //預設為單位 0 
        report.devno = this.message_id.dvno
        report.ser_no = this.message_id.ser_no
        queryUnitBulletinEffect(this.$store.state.userInfo.id, report).then(result => {
          this.changeLoading = false
          if(result.header && result.header.status == '200'){
              this.dataTree[this.currentTableIndex] = result.body
              this.tableRow = {onenews: [{}]}
              setTimeout(() => {
                this.tableRow = result.body
                this.registerHanlink()  // for 難字update
              }, 50);
              this.breadcrumbs.push({name: this.message_id.dvnm, index: '1'})
          }else{
            this.setToastMsg(result.header.message)
          }
        }) 
      }
    },
    
  },
  methods: {  
    ...mapActions([
      'setPageLock'
    ]),
    sumClick (tableData) {  // 計算點閱率
      let numAry = tableData.map(item => {
        if(item.isclick) {
          return 1
        } else {
          return 0
        }
      })
      return (numAry.reduce((a,b)=>a+b) / tableData.length * 100).toFixed(2)
    },
    sumDownload (tableData) {  // 計算下載/點擊率
      let numAry = tableData.map(item => {
        if(item.isdownload) {
          return 1
        } else {
          return 0
        }
      })
      return (numAry.reduce((a,b)=>a+b) / tableData.length * 100).toFixed(2)
    },
    returnTable (bread) {  // 回到上一層
      this.currentTableIndex = bread.index
      this.tableRow = {...this.dataTree[bread.index]}
      this.breadcrumbs = this.breadcrumbs.slice(0, bread.index)
    },
    toNextTable (rowData) {  // 往下一層
      this.changeLoading = true
      let report = {}
      report.showclass = this.currentTableIndex * 1 + 1 + ''
      this.currentTableIndex = this.currentTableIndex * 1 + 1 + ''
      report.devno = rowData.cedevno
      report.ser_no = this.tableRow.onenews[0].ser_no    
      queryUnitBulletinEffect(this.$store.state.userInfo.id, report).then(result => {
        this.changeLoading = false
        if(result.header && result.header.status == '200'){
          this.dataTree[report.showclass] = result.body
          this.tableRow = {onenews: [{}]}
          setTimeout(() => {
            this.tableRow = result.body
            this.registerHanlink()  // for 難字update
          }, 50);
          this.breadcrumbs.push({name: rowData.cedvnm, index: report.showclass})
        }else{
          this.setToastMsg(result.header.message)
          report.showclass = this.currentTableIndex * 1 - 1 + ''
          this.currentTableIndex = this.currentTableIndex * 1 - 1 + ''
        }
      })
    },  
    backClickRateView() { //回查詢列表

      this.$emit('change-status','STATUS_CliCK_RATE_VIEW', {});
    },
  },
  beforeMount () {
  },
  mounted () {
  }
}
</script>